<template>
  <div class="header-box">
    <div class="header">
      <span class="colorspan">{{ titleName }}</span>
    </div>
    <div class="table-content">
      <table border="1">
        <tr>
          <th rowspan="6">复评单位基本情况</th>
          <th style="width: 158px">单位全称</th>
          <td colspan="5"><input type="text" v-model="dataInfo.unitName" /></td>
        </tr>
        <tr>
          <th>申报入口</th>
          <td colspan="5">
            <input type="text" v-model="dataInfo.decEntrance" readonly />
          </td>
        </tr>
        <tr>
          <th>负责人</th>
          <td colspan="2">
            <input type="text" v-model="dataInfo.leader" />
          </td>
          <th>联系电话</th>
          <td colspan="2">
            <input type="text" v-model="dataInfo.phoneOne" />
          </td>
        </tr>

        <tr>
          <th>联系人</th>
          <td colspan="2">
            <input type="text" v-model="dataInfo.contactPerson" />
          </td>
          <th>手机</th>
          <td colspan="2">
            <input type="text" v-model="dataInfo.contactPhone" />
          </td>
        </tr>
        <tr>
          <th>详细地址</th>
          <td colspan="2">
            <input type="text" v-model="dataInfo.address" />
          </td>
          <th>邮编</th>
          <td colspan="2"><input type="text" v-model="dataInfo.zipCode" /></td>
        </tr>
        <tr>
          <th>电子邮箱</th>
          <td colspan="2"><input type="text" v-model="dataInfo.email" /></td>
          <th>电话（传真）</th>
          <td colspan="2">
            <input type="text" v-model="dataInfo.phoneTwo" />
          </td>
        </tr>

        <tr>
          <td colspan="6">
            <textarea
              v-model="dataInfo.content1"
              cols="50"
              rows="11"
              id="contactus"
              placeholder="2019—2022年基地组织制度建设（列明单位主要领导重视社科普及，基地策划制定发展规划和工作计划，社科普及工作绩效考核和评比，专人协调负责科普教育基地建设，建立社科普及工作档案，所在单位每年用于社科普及工作与活动的经费安排等情况）"
              name="contactus"
            ></textarea>
          </td>
        </tr>
        <tr>
          <td colspan="6">
            <textarea
              v-model="dataInfo.content2"
              cols="50"
              rows="11"
              id="contactus"
              placeholder="2019—2022年基地人才队伍建设（列明包括基地社科普及工作人员、社科专家和社科普及志愿者队伍在内的人才队伍建设发展情况）"
              name="contactus"
            ></textarea>
          </td>
        </tr>
        <tr>
          <td colspan="6">
            <textarea
              v-model="dataInfo.content3"
              cols="50"
              rows="11"
              id="contactus"
              placeholder="2019—2022年基地社科普及载体建设（需列明基地固定社科普及活动场所、橱窗、展板、固定宣传栏、电子屏幕等硬件设施和社科普及宣传资料等传统社科普及资源建设，以及网站、三微、移动客户端等新媒体普及载体平台建设情况）"
              name="contactus"
            ></textarea>
          </td>
        </tr>
        <tr>
          <td colspan="6">
            <textarea
              v-model="dataInfo.content4"
              cols="50"
              rows="11"
              id="contactus"
              placeholder="2019—2022年基地社科普及活动开展（需列明参与全省社科普及宣传周，组织开展社科普及活动，基地社科普及工作人员或活动项目获得省市表扬或者获得省市普及项目资助，以及社科普及产品、成果开发情况）"
              name="contactus"
            ></textarea>
          </td>
        </tr>
        <tr>
          <td colspan="6">
            <textarea
              v-model="dataInfo.content5"
              cols="50"
              rows="11"
              id="contactus"
              placeholder="2019—2022年基地社科普及活动的社会影响和辐射带动作用（需列明社科普及活动覆盖范围、宣传报道和资源整合等情况）"
              name="contactus"
            ></textarea>
          </td>
        </tr>
        <!-- <tr>
          <td colspan="6">
            <textarea
              v-model="dataInfo.content6"
              cols="50"
              rows="11"
              id="contactus"
              placeholder="2019—2022年发挥带动和辐射作用情况（含宣传报道、资源整合等，上传证明材料）"
              name="contactus"
            ></textarea>
          </td>
        </tr>
        <tr>
          <td colspan="6">
            <textarea
              v-model="dataInfo.content7"
              cols="50"
              rows="11"
              id="contactus"
              placeholder="2019—2022年扩大社会影响与工作绩效（含覆盖范围、获得奖励等，上传证明材料）"
              name="contactus"
            ></textarea>
          </td>
        </tr> -->
      </table>
    </div>
    <a-spin :spinning="spinning" tip="上传中">
      <div class="upload" >
        2019—2022年基地组织制度建设有关材料
        <a-upload
         v-if="dataInfo.fileName1 == ''"
          :customRequest="uploaderCoverUrlOne"
          :show-upload-list="false"
          accept=".pdf"
        >
          <a-button v-if="saveStatus == 0 || declareStatus == 0" style="margin-top: 10px">
            <a-icon type="upload" />本地上传
          </a-button>
            <a-button v-if="userTypeValue == 'declarator' && declareStatus == 2" style="margin-top: 10px">
            <a-icon type="upload" />本地上传
          </a-button>
        </a-upload>
        <span style="margin-left: 10px" v-if="dataInfo.fileName1 == ''"
          >仅支持PDF格式，限制1个！</span
        >
        <span v-else style="color: #1890ff">
          查看附件：
          <span style="cursor: pointer" @click="preview(1)">{{
            dataInfo.fileName1
          }}</span>
          <a-icon type="close" v-if="saveStatus == 0 || declareStatus == 0" @click="removeFile(1)" />
           <a-icon type="close" v-if="userTypeValue == 'declarator' && declareStatus == 2" @click="removeFile(1)" />

        </span>
      </div>
    </a-spin>
    <a-spin :spinning="spinning2" tip="上传中">
      <div class="upload">
        2019—2022年基地人才队伍建设有关材料
        <a-upload
         v-if="dataInfo.fileName2 == ''"
          :customRequest="uploaderCoverUrlOne2"
          :show-upload-list="false"
          accept=".pdf"
        >
          <a-button v-if="saveStatus == 0 || declareStatus == 0" style="margin-top: 10px">
            <a-icon type="upload" />本地上传
          </a-button>
            <a-button  v-if="userTypeValue == 'declarator' && declareStatus == 2" style="margin-top: 10px">
            <a-icon type="upload" />本地上传
          </a-button>
        </a-upload>
        <span style="margin-left: 10px" v-if="dataInfo.fileName2 == ''"
          >仅支持PDF格式，限制1个！</span
        >
        <span v-else style="color: #1890ff">
          查看附件：
          <span style="cursor: pointer" @click="preview(2)">{{
            dataInfo.fileName2
          }}</span>
          <a-icon type="close" v-if="saveStatus == 0 || declareStatus == 0" @click="removeFile(2)" />
           <a-icon type="close" v-if="userTypeValue == 'declarator' && declareStatus == 2" @click="removeFile(2)" />
        </span>
      </div>
    </a-spin>
    <a-spin :spinning="spinning3" tip="上传中">
      <div class="upload" >
        2019—2022年基地社科普及载体建设有关材料
        <a-upload
         v-if="dataInfo.fileName3 == ''"
          :customRequest="uploaderCoverUrlOne3"
          :show-upload-list="false"
          accept=".pdf"
        >
          <a-button style="margin-top: 10px" v-if="saveStatus == 0 || declareStatus == 0">
            <a-icon type="upload"  />本地上传
          </a-button>
           <a-button style="margin-top: 10px" v-if="userTypeValue == 'declarator' && declareStatus == 2">
            <a-icon type="upload"  />本地上传
          </a-button>
        </a-upload>
        <span style="margin-left: 10px" v-if="dataInfo.fileName3 == ''"
          >仅支持PDF格式，限制1个！</span
        >
        <span v-else style="color: #1890ff">
          查看附件：
          <span style="cursor: pointer" @click="preview(3)">{{
            dataInfo.fileName3
          }}</span>
          <a-icon type="close" v-if="saveStatus == 0 || declareStatus == 0" @click="removeFile(3)" />
          <a-icon type="close" v-if="userTypeValue == 'declarator' && declareStatus == 2" @click="removeFile(3)" />
        </span>
      </div>
    </a-spin>
    <a-spin :spinning="spinning4" tip="上传中">
      <div class="upload" >
        2019—2022年基地社科普及活动开展有关材料
        <a-upload
         v-if="dataInfo.fileName4 == ''"
          :customRequest="uploaderCoverUrlOne4"
          :show-upload-list="false"
          accept=".pdf"
        >
          <a-button style="margin-top: 10px" v-if="saveStatus == 0 || declareStatus == 0">
            <a-icon type="upload" />本地上传
          </a-button>
            <a-button style="margin-top: 10px" v-if="userTypeValue == 'declarator' && declareStatus == 2">
            <a-icon type="upload" />本地上传
          </a-button>
        </a-upload>
        <span style="margin-left: 10px" v-if="dataInfo.fileName4 == ''"
          >仅支持PDF格式，限制1个！</span
        >
        <span v-else style="color: #1890ff">
          查看附件：
          <span style="cursor: pointer" @click="preview(4)">{{
            dataInfo.fileName4
          }}</span>
          <a-icon type="close" v-if="saveStatus == 0 || declareStatus == 0" @click="removeFile(4)" />
          <a-icon type="close" v-if="userTypeValue == 'declarator' && declareStatus == 2" @click="removeFile(4)" />
        </span>
      </div>
    </a-spin>
    <a-spin :spinning="spinning5" tip="上传中">
      <div class="upload" >
        2019—2022年基地社科普及活动的社会影响和辐射带动作用有关材料
        <a-upload
         v-if="dataInfo.fileName5 == ''"
          :customRequest="uploaderCoverUrlOne5"
          :show-upload-list="false"
          accept=".pdf"
        >
          <a-button style="margin-top: 10px" v-if="saveStatus == 0 || declareStatus == 0">
            <a-icon type="upload" />本地上传
          </a-button>
           <a-button style="margin-top: 10px"  v-if="userTypeValue == 'declarator' && declareStatus == 2">
            <a-icon type="upload" />本地上传
          </a-button>
        </a-upload>
        <span style="margin-left: 10px" v-if="dataInfo.fileName5 == ''"
          >仅支持PDF格式，限制1个！</span
        >
        <span v-else style="color: #1890ff">
          查看附件：
          <span style="cursor: pointer" @click="preview(5)">{{
            dataInfo.fileName5
          }}</span>
          <a-icon type="close" v-if="saveStatus == 0 || declareStatus == 0" @click="removeFile(5)" />
          <a-icon type="close" v-if="userTypeValue == 'declarator' && declareStatus == 2" @click="removeFile(5)" />
        </span>
      </div>
    </a-spin>
    <div class="radio" v-if="chooseType == 1 || chooseType == 2">
      <p>市级意见：</p>
      <a-radio-group v-model="dataInfo.cityOpinion" name="radioGroup">
        <a-radio value="优秀">优秀</a-radio>
        <a-radio value="合格">合格</a-radio>
        <a-radio value="不合格">不合格</a-radio>
      </a-radio-group>
    </div>
    <div class="footer">
      <a-button
        type="primary"
        @click="save(0)"
        v-if="saveStatus == 0 || declareStatus == 0"
        >保存草稿</a-button
      >
      <a-button
        type="primary"
        @click="save(0)"
        v-if="saveStatus == 1 && declareStatus == 2"
        >保存草稿</a-button
      >
      <!-- 市级保存按钮 -->
      <!-- <a-button type="primary" @click="save(1)" v-if="toTarget == 'cityAdm'"
        >保存</a-button
      > -->
      <a-button type="primary" @click="save(1)">下一页</a-button>
      <a-button @click="cancel">返回</a-button>
    </div>
  </div>
</template>

<script>
import {
  createdecInformationApi,
  updateDecInformationApi,
  decInformationMyListApi,
  openUploadApi,
} from "@/api/declare";
export default {
  props: {
    chooseType: {
      type: Number,
      default: 0,
    },
    toTarget: {
      type: String,
    },
  },
  data() {
    return {
      userTypeValue: "",
      saveStatus: 0,
      declareStatus: 0,
      titleName: "江苏省社科普及示范基地复评表",
      spinning: false,
      spinning2: false,
      spinning3: false,
      spinning4: false,
      spinning5: false,
      dataInfo: {
        fileName1: "",
        fileUrl1: "",
        fileName2: "",
        fileUrl2: "",
        fileName3: "",
        fileUrl3: "",
        fileName4: "",
        fileUrl4: "",
        fileName5: "",
        fileUrl5: "",
        unitName: "",
        decEntrance: "",
        leader: "",
        phoneTwo: "",
        contactPerson: "",
        contactPhone: "",
        address: "",
        zipCode: "",
        email: "",
        phoneOne: "",
        content1: "",
        content2: "",
        content3: "",
        content4: "",
        content5: "",
        content6: "",
        content7: "",
        municipalOpinion: 0 /*  */,
        cityOpinion: "" /* 市级意见 */,
      },
    };
  },
  methods: {
    uploadSelect(file,i) {
      const isPDF = file.type === 'application/pdf';
      var form = new FormData();
      form.append("multipartFile", file);
      if (!isPDF) {
        this.$message.error(`${file.name} 不是一个PDF文件，请重新上传！`);
      } else {
        openUploadApi(form).then((res) => {
          console.log(res);
          if (i == 1) {
            this.dataInfo.fileUrl1 = res.data;
            this.dataInfo.fileName1 = file.name;
          };
          if (i == 2) {
            this.dataInfo.fileUrl2 = res.data;
            this.dataInfo.fileName2 = file.name;
          };
          if (i == 3) {
            this.dataInfo.fileUrl3 = res.data;
            this.dataInfo.fileName3 = file.name;
          };
          if (i == 4) {
            this.dataInfo.fileUrl4 = res.data;
            this.dataInfo.fileName4 = file.name;
          }
          if (i == 5) {
            this.dataInfo.fileUrl5 = res.data;
            this.dataInfo.fileName5 = file.name;
          }
      });
      }
    },
    uploaderCoverUrlOne(option) {
      this.spinning = true;
      this.uploadSelect(option.file,1);
      this.spinning = false;
    },
    uploaderCoverUrlOne2(option) {
      this.spinning2 = true;
      this.uploadSelect(option.file,2);
      this.spinning2 = false;
    },
    uploaderCoverUrlOne3(option) {
      this.spinning3 = true;
      this.uploadSelect(option.file,3);
      this.spinning3 = false;
    },
    uploaderCoverUrlOne4(option) {
      this.spinning4 = true;
      this.uploadSelect(option.file,4);
      this.spinning4 = false;
    },
    uploaderCoverUrlOne5(option) {
      this.spinning5 = true;
      this.uploadSelect(option.file,5);
      this.spinning5 = false;
    },
    removeFile(i) {
      if (i == 1) {
        this.dataInfo.fileUrl1 = "";
        this.dataInfo.fileName1 = "";
      }
      if (i == 2) {
        this.dataInfo.fileUrl2 = "";
        this.dataInfo.fileName2 = "";
      }
      if (i == 3) {
        this.dataInfo.fileUrl3 = "";
        this.dataInfo.fileName3 = "";
      }
      if (i == 4) {
        this.dataInfo.fileUrl4 = "";
        this.dataInfo.fileName4 = "";
      }
      if (i == 5) {
        this.dataInfo.fileUrl5 = "";
        this.dataInfo.fileName5 = "";
      }
    },
    preview(i) {
      if (i == 1) {
        if (this.dataInfo.fileUrl1.indexOf("https")<0) {
          this.dataInfo.fileUrl1 = this.dataInfo.fileUrl1.replace(
            "http",
            "https"
          );
        }

        let url = `https://storage.tmtsp.com/pdfjs/html_pdf/index.html?file=${this.dataInfo.fileUrl1}`;
        window.open(url);
      }
      if (i == 2) {
        if (this.dataInfo.fileUrl2.indexOf("https")<0) {
          this.dataInfo.fileUrl2 = this.dataInfo.fileUrl2.replace(
            "http",
            "https"
          );
        }

        let url = `https://storage.tmtsp.com/pdfjs/html_pdf/index.html?file=${this.dataInfo.fileUrl2}`;
        window.open(url);
      }
      if (i == 3) {
        if (this.dataInfo.fileUrl3.indexOf("https")<0) {
          this.dataInfo.fileUrl3 = this.dataInfo.fileUrl3.replace(
            "http",
            "https"
          );
        }

        let url = `https://storage.tmtsp.com/pdfjs/html_pdf/index.html?file=${this.dataInfo.fileUrl3}`;
        window.open(url);
      }
      if (i == 4) {
        if (this.dataInfo.fileUrl4.indexOf("https")<0) {
          this.dataInfo.fileUrl4 = this.dataInfo.fileUrl4.replace(
            "http",
            "https"
          );
        }

        let url = `https://storage.tmtsp.com/pdfjs/html_pdf/index.html?file=${this.dataInfo.fileUrl4}`;
        window.open(url);
      }
      if (i == 5) {
        if (this.dataInfo.fileUrl5.indexOf("https")<0) {
          this.dataInfo.fileUrl5 = this.dataInfo.fileUrl5.replace(
            "http",
            "https"
          );
        }

        let url = `https://storage.tmtsp.com/pdfjs/html_pdf/index.html?file=${this.dataInfo.fileUrl5}`;
        window.open(url);
      }
    },
    createdecInformation(i) {
      let obj = JSON.parse(localStorage.getItem("userModel"));
      let params = {
        extraInfo: JSON.stringify(this.dataInfo),
        type: 2,
        fromSource: obj.userType,
        status: i,
        decEntrance: this.dataInfo.decEntrance,
        secondaryDecEntrance:obj.secondaryDecEntrance,
        // filePath: this.fileUrl,
        projectYear: "2023",
        toTarget: "declarator",
        unitName: this.dataInfo.unitName,
        linkMan: this.dataInfo.contactPerson,
        linkPhone: this.dataInfo.contactPhone,
        cityOpinion: this.dataInfo.cityOpinion,
      };
      if (sessionStorage.getItem("declareInfo")) {
        let declareInfoObj = JSON.parse(sessionStorage.getItem("declareInfo"));
        params.id = declareInfoObj.id;
        if (this.userTypeValue == "cityAdm") {
          params.cityCheckUid = obj.productUserId;
        } else {
          params.cityCheckUid = 0;
        }
        params.secondaryDecEntrance=declareInfoObj.secondaryDecEntrance
        if (params.decEntrance !== '部属、省属高校') {
          params.secondaryDecEntrance = ""
        }
        updateDecInformationApi(params).then((res) => {
          if (res.status) {
            this.$message.success(res.message);
            setTimeout(() => {
              this.$emit("backProject");
            }, 1000);
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        params.createUid = obj.productUserId;
        if (params.decEntrance !== '部属、省属高校') {
          params.secondaryDecEntrance = ""
        }
        createdecInformationApi(params).then((res) => {
          if (res.status) {
            this.$message.success(res.message);
            setTimeout(() => {
              this.$emit("backProject");
            }, 1000);
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    save(i) {
      if (i == 1) {
        if (this.dataInfo.unitName == "") {
          this.$message.warn("请填写单位全称");
          return;
        }
        if (this.dataInfo.decEntrance == "") {
          this.$message.warn("请填写申报入口");
          return;
        }
        if (this.dataInfo.leader == "") {
          this.$message.warn("请填写负责人");
          return;
        }
        if (this.dataInfo.phoneOne == "") {
          this.$message.warn("请填写联系电话");
          return;
        }
        if (this.dataInfo.contactPerson == "") {
          this.$message.warn("请填写联系人");
          return;
        }
        if (this.dataInfo.contactPhone == "") {
          this.$message.warn("请填写手机");
          return;
        }
        if (this.dataInfo.address == "") {
          this.$message.warn("请填写详细地址");
          return;
        }
        if (this.dataInfo.zipCode == "") {
          this.$message.warn("请填写邮编");
          return;
        }
        if (this.dataInfo.email == "") {
          this.$message.warn("请填写电子邮箱");
          return;
        }
        if (this.dataInfo.phoneTwo == "") {
          this.$message.warn("请填写电话（传真）");
          return;
        }
        if (this.dataInfo.content1 == "") {
          this.$message.warn("请填写2019—2022年基地组织制度建设");
          return;
        }
        if (this.dataInfo.fileName1 == "") {
          this.$message.warn("请上传2019—2022年基地组织制度建设材料");
          return;
        }
        if (this.dataInfo.content2 == "") {
          this.$message.warn("请填写2019—2022年基地人才队伍建设");
          return;
        }
        if (this.dataInfo.fileName2 == "") {
          this.$message.warn("请上传2019—2022年基地人才队伍建设材料");
          return;
        }
        if (this.dataInfo.content3 == "") {
          this.$message.warn("请填写2019—2022年基地社科普及载体建设");
          return;
        }
        if (this.dataInfo.fileName3 == "") {
          this.$message.warn("请上传2019—2022年基地社科普及载体建设材料");
          return;
        }
        if (this.dataInfo.content4 == "") {
          this.$message.warn("请填写2019—2022年基地社科普及活动开展");
          return;
        }
        if (this.dataInfo.fileName4 == "") {
          this.$message.warn("请上传2019—2022年基地社科普及活动开展材料");
          return;
        }
        if (this.dataInfo.content5 == "") {
          this.$message.warn(
            "请填写2019—2022年基地社科普及活动的社会影响和辐射带动作用"
          );
          return;
        }
        if (this.dataInfo.fileName5 == "") {
          this.$message.warn(
            "请上传2019—2022年基地社科普及活动的社会影响和辐射带动作用材料"
          );
          return;
        }
        // if (this.dataInfo.content6 == "") {
        //   this.$message.warn("请填写2019—2022年发挥带动和辐射作用情况");
        //   return;
        // }
        // if (this.dataInfo.content7 == "") {
        //   this.$message.warn("请填写2019—2022年扩大社会影响与工作绩效");
        //   return;
        // }
        if (
          this.dataInfo.cityOpinion == "" &&
          sessionStorage.getItem("declareInfo") &&
          (this.chooseType == 1 || this.chooseType == 2)
        ) {
          this.$message.warn("请选择市级意见");
          return;
        }
        sessionStorage.setItem("revewInfo", JSON.stringify(this.dataInfo));
        setTimeout(() => {
          this.$emit("nextPage");
        }, 500);
      } else {
        // 保存草稿
        this.createdecInformation(i);
      }
    },
    // 下一页
    nextFn() {
      this.$emit("nextPage");
    },
    cancel() {
      this.$emit("goProject", this.chooseType);
    },
  },
  created() {
    console.log(this.toTarget);
    if (localStorage.getItem("userModel")) {
      let obj = JSON.parse(localStorage.getItem("userModel"));
      this.dataInfo.unitName = obj.unitName;
      this.dataInfo.decEntrance = obj.decEntrance;
      this.userTypeValue = JSON.parse(
        localStorage.getItem("userModel")
      ).userType;
    }
    // 数据清空
    if (
      !sessionStorage.getItem("declareInfo") &&
      !sessionStorage.getItem("revewInfo")
    ) {
      this.saveStatus = 0;
      this.declareStatus = 0;
      this.dataInfo.leader = "";
      this.dataInfo.phoneOne = "";
      this.dataInfo.contactPerson = "";
      this.dataInfo.contactPhone = "";
      this.dataInfo.address = "";
      this.dataInfo.zipCode = "";
      this.dataInfo.email = "";
      this.dataInfo.phoneTwo = "";
      this.dataInfo.content1 = "";
      this.dataInfo.content2 = "";
      this.dataInfo.content3 = "";
      this.dataInfo.content4 = "";
      this.dataInfo.content5 = "";
      this.dataInfo.fileName1 = "";
      this.dataInfo.fileName2 = "";
      this.dataInfo.fileName3 = "";
      this.dataInfo.fileName4 = "";
      this.dataInfo.fileName5 = "";
      this.dataInfo.fileUrl1 = "";
      this.dataInfo.fileUrl2 = "";
      this.dataInfo.fileUrl3 = "";
      this.dataInfo.fileUrl4 = "";
      this.dataInfo.fileUrl5 = "";
      // this.dataInfo.content6 = "";
      // this.dataInfo.content7 = "";
      this.dataInfo.cityOpinion = "";
    }

    if (
      sessionStorage.getItem("declareInfo") &&
      !sessionStorage.getItem("revewInfo")
    ) {
      // 回显
      let declareInfoObj = JSON.parse(sessionStorage.getItem("declareInfo"));
      this.dataInfo.unitName = JSON.parse(declareInfoObj.extraInfo).unitName;
      this.dataInfo.decEntrance = JSON.parse(
        declareInfoObj.extraInfo
      ).decEntrance;
      this.dataInfo.leader = JSON.parse(declareInfoObj.extraInfo).leader;
      this.dataInfo.phoneOne = JSON.parse(declareInfoObj.extraInfo).phoneOne;
      this.dataInfo.contactPerson = JSON.parse(
        declareInfoObj.extraInfo
      ).contactPerson;
      this.dataInfo.contactPhone = JSON.parse(
        declareInfoObj.extraInfo
      ).contactPhone;
      this.dataInfo.address = JSON.parse(declareInfoObj.extraInfo).address;
      this.dataInfo.zipCode = JSON.parse(declareInfoObj.extraInfo).zipCode;
      this.dataInfo.email = JSON.parse(declareInfoObj.extraInfo).email;
      this.dataInfo.phoneTwo = JSON.parse(declareInfoObj.extraInfo).phoneTwo;
      this.dataInfo.content1 = JSON.parse(declareInfoObj.extraInfo).content1;
      this.dataInfo.content2 = JSON.parse(declareInfoObj.extraInfo).content2;
      this.dataInfo.content3 = JSON.parse(declareInfoObj.extraInfo).content3;
      this.dataInfo.content4 = JSON.parse(declareInfoObj.extraInfo).content4;
      this.dataInfo.content5 = JSON.parse(declareInfoObj.extraInfo).content5;
      this.dataInfo.fileName1 = JSON.parse(declareInfoObj.extraInfo).fileName1;
      this.dataInfo.fileUrl1 = JSON.parse(declareInfoObj.extraInfo).fileUrl1;
      this.dataInfo.fileName2 = JSON.parse(declareInfoObj.extraInfo).fileName2;
      this.dataInfo.fileUrl2 = JSON.parse(declareInfoObj.extraInfo).fileUrl2;
      this.dataInfo.fileName3 = JSON.parse(declareInfoObj.extraInfo).fileName3;
      this.dataInfo.fileUrl3 = JSON.parse(declareInfoObj.extraInfo).fileUrl3;
      this.dataInfo.fileName4 = JSON.parse(declareInfoObj.extraInfo).fileName4;
      this.dataInfo.fileUrl4 = JSON.parse(declareInfoObj.extraInfo).fileUrl4;
      this.dataInfo.fileName5 = JSON.parse(declareInfoObj.extraInfo).fileName5;
      this.dataInfo.fileUrl5 = JSON.parse(declareInfoObj.extraInfo).fileUrl5;
      // this.dataInfo.content6 = JSON.parse(declareInfoObj.extraInfo).content6;
      // this.dataInfo.content7 = JSON.parse(declareInfoObj.extraInfo).content7;

      this.dataInfo.cityOpinion = JSON.parse(
        declareInfoObj.extraInfo
      ).cityOpinion;
      if (sessionStorage.getItem("revewInfo")) {
        this.dataInfo.cityOpinion = JSON.parse(
          sessionStorage.getItem("revewInfo")
        ).cityOpinion;
      }
      // this.dataInfo.fileName = JSON.parse(declareInfoObj.extraInfo).fileName;
      // this.fileUrl = declareInfoObj.filePath;
      // this.dataInfo.fileUrl = declareInfoObj.filePath;
      this.declareStatus = declareInfoObj.status;
      this.saveStatus = 1;
    }
    if (sessionStorage.getItem("revewInfo")) {
      // 回显
      let declareInfoObj = JSON.parse(sessionStorage.getItem("revewInfo"));
      this.dataInfo.unitName = declareInfoObj.unitName;
      this.dataInfo.decEntrance = declareInfoObj.decEntrance;
      this.dataInfo.leader = declareInfoObj.leader;
      this.dataInfo.phoneOne = declareInfoObj.phoneOne;
      this.dataInfo.contactPerson = declareInfoObj.contactPerson;
      this.dataInfo.contactPhone = declareInfoObj.contactPhone;
      this.dataInfo.address = declareInfoObj.address;
      this.dataInfo.zipCode = declareInfoObj.zipCode;
      this.dataInfo.email = declareInfoObj.email;
      this.dataInfo.phoneTwo = declareInfoObj.phoneTwo;
      this.dataInfo.content1 = declareInfoObj.content1;
      this.dataInfo.content2 = declareInfoObj.content2;
      this.dataInfo.content3 = declareInfoObj.content3;
      this.dataInfo.content4 = declareInfoObj.content4;
      this.dataInfo.content5 = declareInfoObj.content5;
      this.dataInfo.fileName1 = declareInfoObj.fileName1;
      this.dataInfo.fileUrl1 = declareInfoObj.fileUrl1;
      this.dataInfo.fileName2 = declareInfoObj.fileName2;
      this.dataInfo.fileUrl2 = declareInfoObj.fileUrl2;
      this.dataInfo.fileName3 = declareInfoObj.fileName3;
      this.dataInfo.fileUrl3 = declareInfoObj.fileUrl3;
      this.dataInfo.fileName4 = declareInfoObj.fileName4;
      this.dataInfo.fileUrl4 = declareInfoObj.fileUrl4;
      this.dataInfo.fileName5 = declareInfoObj.fileName5;
      this.dataInfo.fileUrl5 = declareInfoObj.fileUrl5;
      // this.dataInfo.content6 = declareInfoObj.content6;
      // this.dataInfo.content7 = declareInfoObj.content7;
      this.dataInfo.cityOpinion = declareInfoObj.cityOpinion;
      if (sessionStorage.getItem("revewInfo")) {
        this.dataInfo.cityOpinion = JSON.parse(
          sessionStorage.getItem("revewInfo")
        ).cityOpinion;
      }
      // this.dataInfo.fileName = declareInfoObj.fileName;
      // this.fileUrl = declareInfoObj.filePath;
      // this.dataInfo.fileUrl = declareInfoObj.filePath;
      this.declareStatus = declareInfoObj.status;
      this.saveStatus = 1;
    }
    if (sessionStorage.getItem("revewInfo") && sessionStorage.getItem("declareInfo")) {
      let declareInfoObj = JSON.parse(sessionStorage.getItem("declareInfo"));
      this.declareStatus = declareInfoObj.status;
    }
    if (sessionStorage.getItem("revewInfo") && !sessionStorage.getItem("declareInfo")) {
      this.declareStatus = 0;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
